module.exports = __webpack_public_path__ + "images/background-blue-2-4a8c924918754236b532262d947ae3d0.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/background-blue-2.svg
// module id = 5
// module chunks = 0